import { atom, useAtom } from 'jotai';

const sendStxDialogAtom = atom<boolean>(false);
const sendStxTokenAtom = atom<any>(null);

export const useSendStxDialog = () => {
  const [isSendStxDialogOpen, setSendStxDialogOpen] = useAtom(sendStxDialogAtom);
  const [selectedTokenIndex, setSelectedTokenIndex] = useAtom(sendStxTokenAtom);

  return {
    isSendStxDialogOpen,
    setSendStxDialogOpen,
    selectedTokenIndex,
    setSelectedTokenIndex,
  };
};
